import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { formatMoneda, validaMonto, validaSoloNumero } from "../../util/varios";
import CatalogoCatProgramatica from "../../catalogos/catalogoCategoriaProgramatica";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import TablaClasificador from "./tablaClasificador";
import moment from "moment";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";
import { Radio, Input, Textarea } from "../../ui/inputs/Input";

export const ActualizarCuadroObras = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));

  const [activate, setActivate] = useState(false);
  const [deshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [mostrar3, setMostrar3] = useState(false);
  const [actiiva, setActiiva] = useState(true);
  const [datospre, setDatospre] = useState([]);
  const [valida, setValida] = useState(0);
  const [val, setVal] = useState(0.0);
  const [val2, setVal2] = useState(0.0);
  const [idrecurso, setIdrecurso] = useState(0);
  const [idcat, setIdcat] = useState(0);
  const [idpc, setIdpc] = useState(0);
  const [proyecto, setProyecto] = useState(0);
  const [cat, setCat] = useState(0);
  const [pucc, setPucc] = useState(0);
  const [puccd, setPuccd] = useState(0);
  const [idpucd, setIdpucd] = useState(0);
  const [data, setData] = useState([]);
  const [chek, setChek] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const [body, setBody] = useState(null);
  const txtIdd = useRef();
  const txtOrdinario = useRef();
  const txtFci = useRef();
  const txtInstitu = useRef();
  const txtSi = useRef();
  const txtNo = useRef();
  const btnCat = useRef();
  const txtDescriclas = useRef();
  const txtDescriaux = useRef();
  const txtMonto = useRef();
  const txtAuxiliar = useRef();
  const txtDescriubi = useRef();
  const txtMontoClass = useRef();
  const txtNp = useRef();
  const txtNpd = useRef();
  const txt1 = useRef();
  const txt2 = useRef();
  const txt3 = useRef();
  const txt4 = useRef();
  const txt5 = useRef();
  const txt6 = useRef();
  const txt7 = useRef();
  const txt8 = useRef();
  const txt9 = useRef();

  const onChange = (event) => {
    if (
      event.target.name === "descriaux" ||
      event.target.name === "ubicacion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
  };

  const onCheck = () => {
    let mont = txtMontoClass.current.value
      .trim()
      .replace(/\./g, "")
      .replace(",", ".");
    if (txtSi.current.checked) {
      /* let monto = txtMonto.current.value
        .trim()
        .replace(/\./g, "")
        .replace(",", ".");
      seleccionarClassific(monto); */
      setChek(1);
      calcularIva();
    } else if (txtNo.current.checked) {
      let monto = txtMonto.current.value
        .trim()
        .replace(/\./g, "")
        .replace(",", ".");
      let total = 0.0;
      setChek(0);

      txt6.current.value = "";
      txt7.current.value = "";
      txt8.current.value = "";
      txt9.current.value = "";
      txtDescriclas.current.value = "";
      txtMontoClass.current.value = "";

      total = parseFloat(monto) - parseFloat(mont);
      txtMonto.current.value = formatMoneda(
        total.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
  };

  const calcularIva = () => {
    let monto = txtMonto.current.value
      .trim()
      .replace(/\./g, "")
      .replace(",", ".");
    seleccionarClassific(monto);
  }

  const SeleccionarRecursos = () => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/presupuesto/seleccionarrecursos?idefiscal=${idefiscal}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data > 0) {
            setIdrecurso(response.data.idcuenta);
          } else {
            setIdrecurso(0);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SeleccionarSequencia = () => {
    let endpoint = `${op.conexion}/api/presupuesto/sequencia`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setProyecto(response.data.numproyect);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (
      txtOrdinario.current.checked === false &&
      txtInstitu.current.checked === false &&
      txtFci.current.checked === false
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el Tipo",
        icono: "informacion",
      });
      sigue = false;
      txtOrdinario.current.focus();
    } else if (
      txtSi.current.checked === false &&
      txtNo.current.checked === false
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el IVA",
        icono: "informacion",
      });
      sigue = false;
      txtSi.current.focus();
    } else if (txt1.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Categoria Programatica",
        icono: "informacion",
      });
      sigue = false;
      btnCat.current.focus();
    } else if (txtDescriaux.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa el Proyecto",
        icono: "informacion",
      });
      sigue = false;
      txtDescriaux.current.focus();
    } else if (txtDescriubi.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Ubicación",
        icono: "informacion",
      });
      sigue = false;
      txtDescriubi.current.focus();
    } else if (txtAuxiliar.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Auxiliar no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtAuxiliar.current.focus();
    } else if (valida === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el Clasificador Presupuestario",
        icono: "informacion",
      });
      sigue = false;
    } else if (sigue) {
      let datos = [];
      let dataiva = [];

      if (operacion === 1) {
        for (let e = 0; e < data.length; e++) {
          datos.push({
            m_cCat: cat.trim(),
            m_cCta: data[e].puc,
            m_cAux: txtAuxiliar.current.value.trim(),
            m_cDescAux: txtDescriaux.current.value.trim(),
            m_nMontoInicial: data[e].monto
              .trim()
              .replace(/\./g, "")
              .replace(",", "."),
            m_nEfiscal: idefiscal,
            m_nIdCatPro: parseInt(idcat),
            m_nIdPuc: parseInt(data[e].id),
            m_cSecgeo: txtDescriubi.current.value.trim(),
            m_nTippar: 0,
            m_nTipCue: txtOrdinario.current.checked
              ? 1
              : txtInstitu.current.checked
                ? 4
                : 5,
            m_proy: proyecto,
            m_recu: 0,
            m_gace: "",
            m_extr: "",
            m_fech: moment.utc(fechaSistema).format("YYYY-MM-DD"),
            m_usu: parseInt(idusuario),
          });
        }
        if (txtSi.current.checked) {
          dataiva.push({
            m_cCat: cat.trim(),
            m_cCta: puccd.trim(),
            m_cAux: txtAuxiliar.current.value.trim(),
            m_cDescAux: txtDescriclas.current.value.trim(),
            m_nMontoInicial: val,
            m_nEfiscal: idefiscal,
            m_nIdCatPro: parseInt(idcat),
            m_nIdPuc: parseInt(idpucd),
            m_cSecgeo: txtDescriubi.current.value.trim(),
            m_nTippar: 0,
            m_nTipCue: txtOrdinario.current.checked
              ? 1
              : txtInstitu.current.checked
                ? 4
                : 5,
            m_proy: proyecto,
            m_recu: 0,
            m_gace: "",
            m_extr: "",
            m_fech: moment.utc(fechaSistema).format("YYYY-MM-DD"),
            m_usu: parseInt(idusuario),
          });
        }
      } else if (operacion === 2) {
        for (let e = 0; e < datospre.length; e++) {
          datos.push({
            m_cCat: props.presu.categoria.trim(),
            m_cCta: datospre[e].puc,
            m_cAux: txtAuxiliar.current.value.trim(),
            m_cDescAux: txtDescriaux.current.value.trim(),
            m_nEfiscal: props.presu.idefiscal,
            m_nIdCatPro: parseInt(props.presu.idcategoriaprogramatica),
            m_nIdPuc: parseInt(datospre[e].idpuc),
          });
        }
        if (txtSi.current.checked) {
          dataiva.push({
            m_cCat: props.presu.categoria.trim(),
            m_cCta: props.class.puc.trim(),
            m_cAux: txtAuxiliar.current.value.trim(),
            m_cDescAux: txtDescriaux.current.value.trim(),
            m_nEfiscal: props.presu.idefiscal,
            m_nIdCatPro: parseInt(props.presu.idcategoriaprogramatica),
            m_nIdPuc: parseInt(props.class.idpuc),
          });
        }
      }

      setBody({
        operacion: operacion,
        movimientos: datos,
        iva: dataiva,
        idf: idefiscal,
      });
      console.log(datos);
      console.log(dataiva);

      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Reversar esta Cuenta?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/crearpresupuestoobras`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Cuadro de Obras Registrado Correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Cuadro de Obras Reversado Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setDatospre([]);
    setActivate(false);
    setChek(0);
    setValida(0);
    setVal(0.0);
    setVal2(0.0);
    setCat(0);
    setPucc(0);
    setPuccd(0);
    setIdcat(0);
    setIdpc(0);
    setIdpucd(0);
    setData([]);
    setActiiva(true);
  };

  const handleCloseSi = () => {
    if (operacion === 1) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    } else if (operacion === 2) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const catalogoCat = (e) => {
    e.preventDefault();
    setMostrar3(true);
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 13 || typeof event.which === "undefined") {
      setValues({ ...values, [event.target.name]: event.target.value });
      if (event.target.value.length === 1) {
        txtAuxiliar.current.value = "000" + event.target.value;
      } else if (event.target.value.length === 2) {
        txtAuxiliar.current.value = "00" + event.target.value;
      } else if (event.target.value.length === 3) {
        txtAuxiliar.current.value = "0" + event.target.value;
      } else if (event.target.value.length === "") {
        txtAuxiliar.current.value = "0000" + event.target.value;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }

    if (event.which === 13) {
      if (event.target.id === "monto") {
        txtMonto.current.focus();
      } else if (event.target.id === "montoclas") {
        txtMontoClass.current.focus();
      }
    }

    // Devuelve el número formateado
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    return formatMoneda(e);
  };

  const handleAceptaCatProgramatica = (
    idcategoriaprogramatica,
    descripcion,
    categoriaprogramatica
  ) => {
    setMostrar3(false);

    txt1.current.value = categoriaprogramatica.substring(0, 2);
    txt2.current.value = categoriaprogramatica.substring(2, 4);
    txt3.current.value = categoriaprogramatica.substring(4, 6);
    txt4.current.value = categoriaprogramatica.substring(6, 8);
    txt5.current.value = categoriaprogramatica.substring(8, 10);
    setCat(categoriaprogramatica);
    setIdcat(idcategoriaprogramatica);
  };

  const handleCancelara = () => {
    setMostrar3(false);
  };

  const BaseDatos = (data) => {
    let mont = 0.0;
    if (data.length > 0) {
      setValida(data[0].id);
      setPucc(data[0].puc);
      setIdpc(data[0].id);
      setData(data);
      for (let i = 0; i < data.length; i++) {
        mont =
          parseFloat(mont) +
          parseFloat(data[i].monto.trim().replace(/\./g, "").replace(",", "."));
      }
      if (txtSi.current.checked) {
        let monto = mont;
        seleccionarClassific(monto);
      }
    } else {
      setValida(0);
      setPucc(0);
      setIdpc(0);
      setData([]);
      txtMontoClass.current.value = "0,00";
    }

    let total = formatMoneda(
      mont.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtMonto.current.value = formatMoneda(
      mont.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    setVal2(total.trim().replace(/\./g, "").replace(",", "."));
    /*if (data[0].id > 0) {
      setActiiva(false);
    }*/
    console.log(total);

  };

  const seleccionarClassific = (monto) => {
    setActivate(true);

    let campos = "puc, trim(descripcion)  AS descripcion, idpuc";
    let nomtab = "puc";
    let nomid = "idefiscal";
    let condic = "puc = '403180100'";

    let endpoint = `${op.conexion}/api/consulta/modelicondi?campos=${campos}&id=${idefiscal}&nomtab=${nomtab}&nomid=${nomid}&condic=${condic}`;
    console.log(endpoint);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          txt6.current.value = response.data[0].puc.substring(0, 3);
          txt7.current.value = response.data[0].puc.substring(3, 5);
          txt8.current.value = response.data[0].puc.substring(5, 7);
          txt9.current.value = response.data[0].puc.substring(7, 9);
          txtDescriclas.current.value = response.data[0].descripcion;
          setPuccd(response.data[0].puc);
          setIdpucd(response.data[0].idpuc);

          let total = 0.0;
          let mont = txtMonto.current.value
            .trim()
            .replace(/\./g, "")
            .replace(",", ".");
          let totalmonto = 0.0;

          total = (parseFloat(monto) * 16) / 100;
          totalmonto = parseFloat(mont) + total;

          setVal(total);
          txtMontoClass.current.value = formatMoneda(
            total.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          txtMonto.current.value = formatMoneda(
            totalmonto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        //SeleccionarRecursos();
        //SeleccionarSequencia();

        if (props.operacion !== 1) {
          setActiiva(true);
          setValues(props.presu);
          console.log(props.presutabla);
          setDatospre(props.presutabla);
          setProyecto(props.presu.proyecto);
          setValida(props.presu.idcuenta);

          if (props.class.idcuenta > 0) {
            let monto = 0.0;
            let montoclass = props.class.disponibilidad;
            let total = 0.0;

            for (let i = 0; i < props.presutabla.length; i++) {
              monto =
                parseFloat(monto) +
                parseFloat(props.presutabla[i].disponibilidad);
            }
            console.log(monto);
            total = parseFloat(monto) + parseFloat(montoclass);
            txtMonto.current.value = formatMoneda(
              total.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );

            if ((props.class.puc = "403180100")) {
              txtSi.current.checked = true;
              txtNo.current.checked = false;
              setChek(1);
            } else {
              setChek(0);
              txtNo.current.checked = true;
              txtSi.current.checked = false;
            }

            txt6.current.value = props.class.puc.substring(0, 3);
            txt7.current.value = props.class.puc.substring(3, 5);
            txt8.current.value = props.class.puc.substring(5, 7);
            txt9.current.value = props.class.puc.substring(7, 9);
            txtDescriclas.current.value = props.class.descripcion;
            txtMontoClass.current.value = formatMoneda(
              props.class.disponibilidad
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
          } else {
            let monto = 0.0;

            for (let i = 0; i < props.presutabla.length; i++) {
              monto =
                parseFloat(monto) +
                parseFloat(props.presutabla[i].disponibilidad);
            }

            txtMonto.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
            setChek(0);
            txtNo.current.checked = true;
          }
        } else {
          setActiiva(false);
          txtSi.current.checked = false;
          txtNo.current.checked = true;
          txtOrdinario.current.checked = true;
          txtInstitu.current.checked = false;
          txtFci.current.checked = false;
          txtDescriaux.current.value = "";
          txtDescriubi.current.value = "";
          txtDescriclas.current.value = "";
          txtMontoClass.current.value = "";
          txtAuxiliar.current.value = "";
          txt1.current.value = "";
          txt2.current.value = "";
          txt3.current.value = "";
          txt4.current.value = "";
          txt5.current.value = "";
          txt6.current.value = "";
          txt7.current.value = "";
          txt8.current.value = "";
          txt9.current.value = "";
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Crear Cuadro de Obras."
              : operacion === 2
                ? "Reversar Cuadro de Obras."
                : operacion === 3
                  ? "Eliminar Cuadro de Obras."
                  : "Consultar Cuadro de Obras."}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <CatalogoCatProgramatica
          show={mostrar3}
          onHideCancelar={handleCancelara}
          onHideAceptaCatProgramatica={handleAceptaCatProgramatica}
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div>
          <input type="hidden" ref={txtNp} />
          <fieldset className="row border-azul rounded mx-auto container">
            <legend className="float-none m-0 w-auto ">Datos</legend>
            <input
              type="hidden"
              className="form-control text-uppercase"
              disabled={true}
              ref={txtIdd}
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={values ? values.idcuenta.trim() : ""}
              id="inputCedula"
            />

            <div className="col-9 m-0 p-0 pr-2">
              <fieldset className="d-flex border-azul rounded">
                <legend className="float-none m-0 w-auto ">Tipo</legend>
                <div className="col-5 m-0 p-0">
                  <Radio
                    label="Obra Ingresos Ordinarios"
                    disabled={
                      operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    defaultChecked={
                      props.presu && props.presu.tipocuenta === 1 ? true : false
                    }
                    name="exampleRadiosuno"
                    id="exampleRadiosuno1"
                    value="option1"
                    ref={txtOrdinario}
                  />
                </div>
                <div className="col-4 m-0 p-0">
                  <Radio
                    label="Institución"
                    disabled={
                      operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    defaultChecked={
                      props.presu && props.presu.tipocuenta === 4 ? true : false
                    }
                    name="exampleRadiosuno"
                    id="exampleRadiosuno2"
                    value="option2"
                    ref={txtInstitu}
                  />
                </div>
                <div className="col-4 m-0 p-0">
                  <Radio
                    label="Obra FCI"
                    disabled={
                      operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    defaultChecked={
                      props.presu && props.presu.tipocuenta === 5 ? true : false
                    }
                    name="exampleRadiosuno"
                    id="exampleRadiosuno3"
                    value="option3"
                    ref={txtFci}
                  />
                </div>
              </fieldset>
            </div>

            <fieldset className="col-3 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none m-0 w-auto ">Obra Posee IVA</legend>
              <div className="col-6 m-0 p-0">
                <Radio
                  label="SI"
                  disabled={actiiva}
                  type="radio"
                  onChange={onCheck}
                  value="option1"
                  name="radioIva"
                  id="exampleRadiosdos1"
                  ref={txtSi}
                />
              </div>

              <div className="col-6 m-0 p-0">
                <Radio
                  label="NO"
                  disabled={actiiva}
                  type="radio"
                  onChange={onCheck}
                  name="radioIva"
                  id="exampleRadiosdos2"
                  value="option2"
                  ref={txtNo}
                />
              </div>
            </fieldset>
          </fieldset>

          <fieldset className="col-12 m-0 p-2 d-flex flex-wrap justify-content-end border-azul rounded mx-auto">
            <legend className="float-none m-0 w-auto ">
              Categoria Programatica
            </legend>

            <div className="input-group input-group-sm col-md-12 mb-1">
              <table class="col-11 mb-1 table table-responsive px-0 border">
                <thead>
                  <tr>
                    <th className="text-center" scope="col">
                      Sector
                    </th>
                    <th className="text-center" scope="col">
                      Prog
                    </th>
                    <th className="text-center" scope="col">
                      SubProg
                    </th>
                    <th className="text-center" scope="col">
                      Proy
                    </th>
                    <th className="text-center" scope="col">
                      Act
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <input
                        type="text"
                        disabled={true}
                        maxLength="2"
                        name="uno"
                        ref={txt1}
                        onChange={onChange}
                        onChangeCapture={handleInputNumChange}
                        defaultValue={
                          props.presu
                            ? props.presu.categoria.substring(0, 2)
                            : ""
                        }
                        className="form-control text-uppercase mr-1 text-center"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputLogin"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        disabled={true}
                        maxLength="2"
                        name="dos"
                        ref={txt2}
                        onChange={onChange}
                        onChangeCapture={handleInputNumChange}
                        defaultValue={
                          props.presu
                            ? props.presu.categoria.substring(2, 4)
                            : ""
                        }
                        className="form-control text-uppercase mr-1 text-center"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputLogin"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        disabled={true}
                        maxLength="2"
                        name="tres"
                        ref={txt3}
                        onChange={onChange}
                        onChangeCapture={handleInputNumChange}
                        defaultValue={
                          props.presu
                            ? props.presu.categoria.substring(4, 6)
                            : ""
                        }
                        className="form-control text-uppercase mr-1 text-center"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputLogin"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        disabled={true}
                        maxLength="2"
                        name="cuatro"
                        ref={txt4}
                        onChange={onChange}
                        onChangeCapture={handleInputNumChange}
                        defaultValue={
                          props.presu
                            ? props.presu.categoria.substring(6, 8)
                            : ""
                        }
                        className="form-control text-uppercase mr-1 text-center"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputLogin"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        disabled={true}
                        maxLength="2"
                        name="cinco"
                        ref={txt5}
                        onChange={onChange}
                        onChangeCapture={handleInputNumChange}
                        defaultValue={
                          props.presu
                            ? props.presu.categoria.substring(8, 10)
                            : ""
                        }
                        className="form-control text-uppercase text-center"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputLogin"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="col d-flex">
                <button
                  disabled={
                    operacion === 4 || operacion === 2 ? true : deshabilitado
                  }
                  ref={btnCat}
                  onClick={catalogoCat}
                  className="btn btn-sm  btn-info my-auto mx-auto rounded-circle"
                >
                  <i className="fa fa-search"></i>{" "}
                </button>
              </div>
            </div>

            <div className="col-6 col-md-4 m-0 mb-2 p-0 d-flex">
              <Input
                label="Proyecto N°"
                disabled={
                  operacion === 4 || operacion === 2 ? true : deshabilitado
                }
                maxLength="4"
                onBlur={handleInputNumChange}
                onKeyUp={handleInputNumChange}
                defaultValue={props.presu ? props.presu.auxiliar : ""}
                placeholder="0000"
                name="nproyecto"
                id="inputLogin"
                ref={txtAuxiliar}
              />
              <span className="col-1 d-flex align-items-center justify-content-center m-0 p-0">
                -
              </span>
              <div className="col-4 m-0 p-0">
                <Input
                  maxLength="2"
                  disabled={true}
                  name="npdos"
                  id="inputLogin"
                  ref={txtNpd}
                />
              </div>
            </div>

            <div className="col-md-12 mx-auto px-0 row">
              <div className="col-6 m-0 mb-2 p-0">
                <Textarea
                  label="Descripción del Proyecto"
                  style={{ height: 50 }}
                  onChangeCapture={onChange}
                  name="descriaux"
                  disabled={
                    operacion === 4 || operacion === 2 ? true : deshabilitado
                  }
                  defaultValue={props.presu ? props.presu.descripcionaux : ""}
                  placeholder="Descripción del Proyecto"
                  id="inputDireccion"
                  ref={txtDescriaux}
                />
              </div>

              <div className="col-6 m-0 p-0">
                <Textarea
                  label="Ubicación Geografica del Proyecto"
                  style={{ height: 50 }}
                  onChangeCapture={onChange}
                  name="ubicacion"
                  disabled={
                    operacion === 4 || operacion === 2 ? true : deshabilitado
                  }
                  defaultValue={props.presu ? props.presu.sectorgeog : ""}
                  placeholder="Descripción de la Ubicación del Proyecto"
                  id="inputDireccion"
                  ref={txtDescriubi}
                />
              </div>
            </div>
          </fieldset>

          <fieldset className="row border-azul rounded mx-auto">
            <legend className="float-none m-0 w-auto ">
              Clasificador Presupuestario
            </legend>

            <div className="col-md-12 px-0">
              <TablaClasificador
                modal="obra"
                data={BaseDatos}
                datarecords={datospre}
                operacion={operacion}
              />
            </div>
          </fieldset>

          <fieldset className="col-12 m-0 p-2 d-flex flex-wrap gap-2 border-azul rounded">
            <legend className="float-none m-0 w-auto ">
              Clasificador Presupuestario IVA
            </legend>

            <div className="col-2 m-0 p-0">
              <Input
                label="Ramo:"
                disabled={true}
                maxLength="3"
                name="uno"
                onChange={onChange}
                onChangeCapture={handleInputNumChange}
                id="inputLogin"
                ref={txt6}
              />
            </div>
            <div className="col-2 m-0 p-0">
              <Input
                label="Gen:"
                disabled={true}
                maxLength="2"
                name="dos"
                ref={txt7}
                onChange={onChange}
                onChangeCapture={handleInputNumChange}
                id="inputLogin"
              />
            </div>
            <div className="col-2 m-0 p-0">
              <Input label='Espec:'
                disabled={true}
                maxLength="2"
                onChange={onChange}
                onChangeCapture={handleInputNumChange}
                id="inputLogin"
                name="tres"
                ref={txt8}
              />
            </div>
            <div className="col-2 m-0 p-0">
              <Input label='SubEsp:'
                disabled={true}
                maxLength="2"
                onChange={onChange}
                onChangeCapture={handleInputNumChange}
                id="inputLogin"
                name="cuatro"
                ref={txt9}
              />
            </div>

            <div className="col-12 m-0 p-0">
              <Textarea label='Descripción'
                style={{ height: 50 }}
                disabled={true}
                placeholder="Descripción del Clasificador Presupuestario"
                id="inputDireccion"
                ref={txtDescriclas}
              />
            </div>
            <div className="col-12 m-0 p-0 d-flex justify-content-end gap-2">
              <div className="col-4 m-0 p-0">
                <Input label='Monto:'
                  autoComplete="off"
                  disabled={true}
                  onBlur={handleInputMontoChange}
                  onKeyUp={handleInputMontoChange}
                  placeholder="0,00"
                  id="montoclas"
                  ref={txtMontoClass}
                />
              </div>
              <div className="col-4 m-0 p-0">
                <Input label='Monto Total de la Obra:'
                  autoComplete="off"
                  disabled={true}
                  onBlur={handleInputMontoChange}
                  onKeyUp={handleInputMontoChange}
                  placeholder="0,00"
                  id="monto"
                  ref={txtMonto}
                />
              </div>
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={onChangeValidar}
          disabled={operacion === 4 ? true : false}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
